import Toolbar from "@mui/material/Toolbar";
import Head from "next/head";
import { Fragment, useEffect, useState } from "react";
import ToResolveClassNameError from "../../components/hoc/ToResolveClassNameError";
import WithFooter from "../../components/hoc/WithFooter";
import SharedFooter from "../../components/shared/SharedFooter/SharedFooter";
import SharedNavbar2 from "../../components/shared/SharedNavbar/Navbar/Navbar";
import UpdatePageContent from "../../components/updates/UpdatePageContent";
import { strapiCall } from "../../utils/api";

function UpdatesPage(props) {
  const [content, setContent] = useState("");

  async function fetchUpdatesData() {
    const payload = {
      query: `
        query {
          updatesPage {
            data {
              attributes {
                content
              }
            }
          }
        }
          `,
    };

    const response = await strapiCall(payload);
    if (response.status === 200) {
      const { data } = response?.data?.data?.updatesPage || {};
      if (data) {
        setContent(data.attributes?.content);
      }
    }
  }

  useEffect(() => {
    fetchUpdatesData();
  }, []);

  let metaTitle = "New Updates - Hiredly - Find Jobs in Malaysia";
  let metaDescription =
    "New Updates - Hiredly. Find full time, internship and work from home jobs in Malaysia. Upload your resume and let our headhunters find a job vacancy for you.";

  return (
    <Fragment>
      <Head>
        {/* <!-- Primary Meta Tags --> */}
        <title>{metaTitle}</title>
        <meta name="title" content={metaTitle} />
        <meta name="description" content={metaDescription} />

        {/* <!-- Open Graph / Facebook --> */}
        <meta property="og:type" content="website" key={"ogType"} />
        <meta
          property="og:url"
          content="https://my.hiredly.com/updates"
          key="ogUrl"
        />
        <meta property="og:title" content={metaTitle} key="ogTitle" />
        <meta
          property="og:description"
          content={metaDescription}
          key="ogDescription"
        />
        {/* <meta
          property="og:image"
          content={
            config.assetDomain + "/images/hiredly/hiredly-meta-image-v1.png"
          }
          key="ogImage"
        /> */}

        {/* <!-- Twitter --> */}
        <meta
          property="twitter:card"
          content="summary_large_image"
          key="twitterCard"
        />
        <meta
          property="twitter:url"
          content="https://my.hiredly.com/updates"
          key="twitterUrl"
        />
        <meta property="twitter:title" content={metaTitle} key="twitterTitle" />
        <meta
          property="twitter:description"
          content={metaDescription}
          key="twitterDescription"
        />
        {/* <meta
          property="twitter:image"
          content={
            config.assetDomain + "/images/hiredly/hiredly-meta-image-v1.png"
          }
          key="twitterImage"
        /> */}
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width"
        />
        <link rel="canonical" href="https://my.hiredly.com/updates" />
      </Head>

      <ToResolveClassNameError>
        <WithFooter>
          <ToResolveClassNameError>
            <SharedNavbar2 />
          </ToResolveClassNameError>

          <Toolbar />
          <UpdatePageContent content={content} />
        </WithFooter>

        <ToResolveClassNameError>
          <SharedFooter />
        </ToResolveClassNameError>
      </ToResolveClassNameError>
    </Fragment>
  );
}

export default UpdatesPage;
